<template>
  <div class="cp-product">
    <span v-if="sale" class="cp-product-sale-tag has-text-white has-text-weight-bold">SALE</span>
    <div class="cp-product-image-section">
        <img class="cp-product-image" :src="image" @click="$emit('click')" />
        <!-- <div class="cp-product-black-tab"></div> -->
        <div class="overlay overlayFade">
            <div class="cp-product-detail">
                <p :class="['is-size-10','cp-product-detail-title']">
                    <span v-html="title" class="has-text-white"></span>
                </p>
                <b-button
                    @click="$emit('click')" class="md-button-bg has-text-white">
                    View
                </b-button>
            </div>
        </div>
    </div>
    <!-- <div class="has-text-center cp-product-detail">
      <a :class="['is-size-5','has-text-centered','has-text-black']"
         @click="$emit('click')"><span v-html="title"></span>
      </a>
      <p :class="['is-size-6', 'has-text-grey-dark']">
        <span v-html="detail"></span>
        </p>
      <b-button
        @click="$emit('click')" class="md-button-bg">
        View </b-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    title: {
      type: String,
      required: true,
    },
    detail: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    sale: {
      type: Boolean,
    },
    price: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    formatComma(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-product-detail{
    padding-top:50%;
    &-title{
        margin-bottom:20px;
    }
}
.overlay {
 position: absolute;
 transition: all 0.3s ease;
 opacity: 0;
 background-color: black;
 cursor: pointer;
}
.cp-product-image-section:hover .overlay{
 opacity: 0.7;
}
.overlayFade {
 height: 90%;
 width: 92%;
 top: 0;
//  left: 0;
 background-color: black;
 margin-top:10px;
 cursor: pointer;
  @media screen and (max-width: 900px) {
       height: 70%;
       width: 65%;
       margin-top: 40px;
       margin-left: 40px;
    }
}
.md-button-bg{
  padding: 5px 30px 5px 30px;
  border-color: orange;
  background: black;
  color:white;
  font-weight: bold;
//   background: url("../assets/img/home/button-menu-active.png");
//   background-position: center;
}
.cp-product {
  width: 300px;
//   margin-top: 20px;
  position: relative;
//   padding-top: 40px;
  @media screen and (max-width: 900px) {
    padding-top: 0px !important;
  }
  &-image {
    display: block;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    // width: 120px;
    // height: 200px;
    cursor: pointer;

     @media screen and (max-width: 900px) {
       padding: 40px !important;
    }
  }
  &-black-tab{
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    margin-bottom: 10%;
    margin-left: auto;
    margin-right: auto;
    background: -moz-linear-gradient(top,transparent 0%,transparent 1%,rgba(0,0,0,0.78) 100%);
    background: -webkit-linear-gradient(top,transparent 0%,transparent 1%,rgba(0,0,0,0.78) 100%);
    background: black;
    opacity: 0.5;
    z-index: 5;
    bottom: 0;
  }
//    &-detail{
//        position: relative;
//    }
  &-sale-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background-color: #ff0000;
    border-radius: 3px 4px 4px 3px;
    // border-left: 1px solid #ff0000;
    margin-left: 19px;
    position: absolute;
    border-radius: 30px;
    // padding: 0 10px 0 10px;
    // top: 0;

    &:before {
      // content: '';
      // position: absolute;
      // display: block;
      // left: -19px;
      // width: 0;
      // height: 0;
      // border-top: 19px solid transparent;
      // border-bottom: 19px solid transparent;
      // border-right: 19px solid #ff0000;
      // border-radius: 5px;
    }

    &:after {
      content: '';
      background-color: white;
      border-radius: 50%;
      width: 4px;
      height: 4px;
      display: block;
      position: absolute;
      left: -9px;
      top: 17px;
    }
  }

  &-price-section {
    display: flex;
  }

  &-discount {
    margin-right: 10px;
  }

  &-price-with-discount {
    position: relative;

    &::before {
      position: absolute;
      content: '';
      left: 0;
      top: 50%;
      right: 0;
      border-top: 1px solid;
      border-color: inherit;

      transform: rotate(-5deg);
    }
  }
}
</style>
